import React from "react";
import SentimentProductInfo from "components/Product-Info-Pages/Sentiment/SentimentProductInfo";

const Sentiment = () => <SentimentProductInfo />;

export default Sentiment;
